import { useMemo } from "react";
import {
  PASSWORD_STRENGTH_LABELS,
  type PasswordStrength,
} from "./types";
import {
  evaluatePasswordStrength,
  passwordStrengthColor,
  passwordStrengthPercent,
} from "./password";

export interface PasswordStrengthMeterProps {
  password: string;
  showLabel?: boolean;
  showBreachCheckMicrocopy?: boolean;
}

export function PasswordStrengthMeter({
  password,
  showLabel = true,
  showBreachCheckMicrocopy = false,
}: PasswordStrengthMeterProps) {
  const strength: PasswordStrength = useMemo(
    () => evaluatePasswordStrength(password),
    [password],
  );
  const percent = passwordStrengthPercent(strength);
  const color = passwordStrengthColor(strength);
  const filled = password?.length > 0;

  return (
    <div className="sc-identity-password-meter" role="group" aria-label="Password strength">
      <div
        className="sc-identity-password-meter__track"
        style={{ background: "#e5e9f2" }}
        aria-hidden
      >
        <div
          className="sc-identity-password-meter__fill"
          style={{
            width: filled ? `${percent}%` : "0%",
            background: filled ? color : "transparent",
          }}
        />
      </div>
      {showLabel && filled && (
        <div
          className="sc-identity-password-meter__label"
          style={{ color }}
          aria-live="polite"
        >
          {PASSWORD_STRENGTH_LABELS[strength]}
        </div>
      )}
      {showBreachCheckMicrocopy && (
        <div className="sc-identity-password-meter__microcopy">
          SpeedyCore Identity checks your password against known breach databases.
        </div>
      )}
    </div>
  );
}
